<script>
    import { countries } from '../countries';
    import { createEventDispatcher } from 'svelte';
    import { lang } from '../language';
    import { configCommunities } from '../mods/configCommunities';
    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let i18n = 'en';
    export let value = configCommunities[i18n].country;

    //METHODS
    const changeCountry = (value) => {
        for (let country of countries) {
            if (country.iso === value) {
                dispatch('country', country);
            }
        }
    };

    //TOP COUNTRIES LIST
    const topCountries = configCommunities[i18n].topCountries.map((iso) =>
        countries.find((country) => country.iso === iso)
    );
    //OTHER COUNTRIES LIST
    const otherCountries = countries.filter((country) => country.iso && !topCountries.includes(country));

    //MERGE BOTH LIST WITH A SEPARATOR
    const _countries = [...topCountries, ...otherCountries];

    //CHANGE THE NAME OF THE COUNTRIES FOR THEIR GOOD TRANSLATIONS
    for (let country of _countries) {
        country.name = lang[i18n].countries[country.iso3];
    }
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_flex-column app-msi_align-items-center">
    <div class="app-msi_form-row">
        <div class="app-msi_form-group">
            <select
                {value}
                class="app-msi_form-control"
                on:change={(event) => {
                    changeCountry(event.target.value);
                }}
            >
                {#each _countries as country}
                    <option value={country.iso} disabled={!country.iso}>{country.name}</option>
                {/each}
            </select>
        </div>
    </div>
</div>
